import React from 'react';
import {
  SimpleGrid,
  Box,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  Icon,
  Flex,
  Text,
  Progress
} from '@chakra-ui/react';
import {
  MdEmail,
  MdOpenInNew,
  MdTouchApp,
  MdBlock,
  MdCheckCircle,
  MdCancel
} from 'react-icons/md';
import { FaPercentage, FaChartLine } from 'react-icons/fa';

const MetricsCards = ({ metrics }) => {
  const cards = [
    {
      label: 'Total de Campanhas',
      value: metrics.totalCampaigns,
      icon: MdEmail,
      color: 'blue.500',
      bgColor: 'blue.50'
    },
    {
      label: 'Emails Enviados',
      value: metrics.totalSent.toLocaleString('pt-BR'),
      icon: MdCheckCircle,
      color: 'green.500',
      bgColor: 'green.50'
    },
    {
      label: 'Emails Entregues',
      value: metrics.totalDelivered.toLocaleString('pt-BR'),
      helper: `${((metrics.totalDelivered / metrics.totalSent) * 100).toFixed(1)}% de entrega`,
      icon: MdCheckCircle,
      color: 'green.600',
      bgColor: 'green.50'
    },
    {
      label: 'Total de Aberturas',
      value: metrics.totalOpened.toLocaleString('pt-BR'),
      helper: `Taxa média: ${metrics.avgOpenRate}%`,
      icon: MdOpenInNew,
      color: 'purple.500',
      bgColor: 'purple.50'
    },
    {
      label: 'Total de Cliques',
      value: metrics.totalClicked.toLocaleString('pt-BR'),
      helper: `Taxa média: ${metrics.avgClickRate}%`,
      icon: MdTouchApp,
      color: 'orange.500',
      bgColor: 'orange.50'
    },
    {
      label: 'Emails Rejeitados',
      value: metrics.totalBounced.toLocaleString('pt-BR'),
      helper: `${((metrics.totalBounced / metrics.totalSent) * 100).toFixed(1)}% do total`,
      icon: MdBlock,
      color: 'red.500',
      bgColor: 'red.50'
    }
  ];

  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 3, xl: 6 }} spacing={4} mb={6}>
      {cards.map((card, index) => (
        <Box
          key={index}
          bg="white"
          p={4}
          borderRadius="lg"
          shadow="sm"
          borderLeft="4px"
          borderLeftColor={card.color}
          _hover={{ shadow: 'md', transform: 'translateY(-2px)' }}
          transition="all 0.2s"
        >
          <Flex justify="space-between" align="start">
            <Stat>
              <StatLabel color="gray.600" fontSize="sm" fontWeight="medium">
                {card.label}
              </StatLabel>
              <StatNumber fontSize="2xl" fontWeight="bold" color="gray.800">
                {card.value}
              </StatNumber>
              {card.helper && (
                <StatHelpText fontSize="xs" color="gray.500" mt={1}>
                  {card.helper}
                </StatHelpText>
              )}
            </Stat>
            <Box
              p={2}
              bg={card.bgColor}
              borderRadius="lg"
            >
              <Icon as={card.icon} w={6} h={6} color={card.color} />
            </Box>
          </Flex>
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default MetricsCards;